


















import { Component, Prop, Vue } from "vue-property-decorator";
import { Media } from "@/types";
import { mapGetters } from "vuex";
import axios from "@/plugins/axios";

@Component({
  computed: { ...mapGetters(["isLoggedIn"]) }
})
export default class MediaCard extends Vue {
  @Prop() media!: Media;
  @Prop() width!: number;
  @Prop() height!: number;
  dialog = false;
  menu = false;
  deleteDialog = false;
  deleteLoading = false;
  isLoggedIn!: boolean;

  get small() {
    return this.width < 300;
  }

  deleteMedia() {
    this.deleteLoading = true;
    axios
      .delete("/api/media/" + this.media.id)
      .then(() => {
        this.$emit("save");
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.deleteLoading = false;
      });
  }
}
